
import { deleteRequest, putRequest } from './request'

import { DOMAIN  } from './constant'

//====== Folder =====

export const updateFolderTitle = (data: {
  title: string,
  id: string,
}) => {
  return putRequest(`${DOMAIN}/api/folder/title`, data)
}

export const updateFolder = (data: {
  id: string,
  parentId?: string
}) => {
  return putRequest(`${DOMAIN}/api/folder`, data)
}

export const softDeleteFolder = (id: string) => {
  return deleteRequest(`${DOMAIN}/api/folders/soft/${id}`)
}

export const hardDeleteFolder = (id: string) => {
  return deleteRequest(`${DOMAIN}/api/folders/${id}`)
}

export const recoverFolder = (data: {
  id: string
}) => {
  return putRequest(`${DOMAIN}/api/folders/recover`, data)
}